import { useMemo } from "react";
import { useFormSessionRefresh } from "@/api";
import type { Seconds, RefreshTokenResponse, TokenName, TokenRefresher } from "mfe-lib-bfo-shared/session";
import { tokenManager } from "mfe-lib-bfo-shared/session";
import _ from 'lodash';

export function useTokenRefresher() {
    const userMutation = useFormSessionRefresh("user", "/ms-bfo/ms-bfo-auth-session-svc/v1/refresh-session");
    const adminMutation = useFormSessionRefresh("admin", "/ms-bfo/ms-bfo-auth-session-svc/v1/refresh-session");

    const refresher = useMemo<TokenRefresher>(
        () => ({
            refresh: async (tokenName: TokenName, adjustedValidity?: Seconds): Promise<RefreshTokenResponse> => {
                if (tokenName === "user") {
                    return await userMutation.mutateAsync({
                        adjustedValidity: _.isNil(adjustedValidity) ? 0 : adjustedValidity,
                    });
                } else {
                    return await adminMutation.mutateAsync({
                        adjustedValidity: _.isNil(adjustedValidity) ? 0 : adjustedValidity,
                    });
                }
            },
        }),
        [userMutation, adminMutation],
    );

    tokenManager.setRefresher(refresher);
}
